import { useInfiniteQuery } from 'react-query'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

import {
  fetchSearchUserResult,
  GetSearchResultQueryParams,
} from '@dc-shared-web/hooks/api/user/fetchSearchUserResult'

export const useSearchUser = (
  params: Omit<GetSearchResultQueryParams, 'page'>
) => {
  const apiClient = useAxiosContext()

  return useInfiniteQuery({
    queryKey: ['searchUser', JSON.stringify(params)],
    queryFn: ({ pageParam = 0 }) =>
      fetchSearchUserResult(apiClient, {
        ...params,
        page: pageParam + 1,
      }),
    getNextPageParam: (lastPage, pages) =>
      lastPage.meta.pages > pages.length ? pages.length : undefined,
  })
}
